import CampaignIcon from '@mui/icons-material/Campaign';
import { Paper, PaperProps, Typography, TypographyProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RemindingTone } from '../api/gql';
import { getRemindingToneTransKey } from '../utils/invoice';
import { ExpandedBox } from './ExpandedBox';
import { FullSizeLoader } from './FullSizeLoader';

type Props = {
  tone: RemindingTone;
  isLoading?: boolean;
  errorMessage?: string;
  titleProps?: TypographyProps;
  showIcon?: boolean;
} & PaperProps;

export const RemindingToneInfoBox = ({
  tone,
  isLoading,
  errorMessage,
  showIcon = true,
  sx,
  titleProps,
  ...rest
}: Props) => {
  const { t } = useTranslation();
  return (
    <Paper sx={{ p: { md: 4, xs: 2 }, position: 'relative', ...sx }} {...rest}>
      {isLoading ? <FullSizeLoader /> : null}
      {errorMessage ? (
        <ExpandedBox sx={{ backdropFilter: 'blur(2px)', zIndex: 10 }}>
          <Typography>{errorMessage}</Typography>
        </ExpandedBox>
      ) : null}
      <Typography variant={'h3'} mb={2} {...titleProps}>
        {showIcon ? <CampaignIcon color={'inherit'} sx={{ mr: 2 }} /> : null}
        {t('remindingTone.title')}
      </Typography>
      <Typography>{t(getRemindingToneTransKey(tone))}</Typography>
    </Paper>
  );
};
